import { createFileRoute, redirect } from '@tanstack/react-router';

// Retired: the farm-wide batch spreadsheet + multi-pond cards are consolidated
// into the single adaptive entry surface (all-ponds scope).
export const Route = createFileRoute('/_app/entry/batch')({
  validateSearch: (search: Record<string, unknown>) => ({
    date: typeof search.date === 'string' ? search.date : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/entry', search: { scope: 'all', date: search.date } });
  },
});
